module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-no",
    attrs: {
      "id": "C1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("One")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "title-head"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABYLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("There are few things as poignant as a tiny tombstone marking the death of a child whose time on earth is measured in just a few minutes or a few years. Children’s tombstones often speak of angels called to heaven. Sometimes, angels are used for comfort and to show protection. Lambs, imparting the innocence of children, are often found on graves. Family photographs may be taken with the deceased. Customs surrounding the burial of children in Southern Arizona are especially influenced by the Mexican Day of the Dead celebrations. On October 31, families welcome the souls of the deceased back to earth for one day. Their graves are decorated with flowers, fruits, and—in the case of children—toys. For three years after the death of a child, the godparents decorate arches over the graves in the belief that the soul enters eternity through arches. The church bells ring, calling children’s souls and the living relatives, and incense provides an aroma to guide the returning spirits.")])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Pioneer families like Leonardo Romero’s often had portraits—like this 1890 photograph—taken with a deceased person. From left to right are Feliciano, Librada, Ysidro (kneeling), Leonardo Jr., Diego, Ramona, three unidentified people, Leonardo Sr., and two unidentified children. With the advent of photography, memories could finally be made tangible. (Courtesy of the Arizona Historical Society.)")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The death of a young mother and her one-month-old infant daughter is all the more heartrending when one considers that she is buried in the Pima County indigent cemetery. Harriet Davis died on February 15, 1876. She was 27 years old when she died, but her birth date is not known. She and her daughter were originally buried in Tucson’s downtown cemetery.")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F3.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Edith Bessy Riggs was born into a prominent southeastern Arizona ranching family, but she spent barely more than a year on this earth. The daughter of Swedish immigrants, she was born on August 2, 1884, and died on August 9, 1885. At the time, there was little in the way of medical assistance when anyone—especially a child—became sick or hurt on the frontier.")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Christian Keith Ongley’s grave marker says it all. Born on October 2, 1996, he died on October 4, 1996. His grave, located in Tucson’s Evergreen Cemetery, is decorated with a baby picture, several toy cars, and, of course, an innocent lamb.")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F5.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("There is no name on this grave, but a wonderful verse appears on a tiny marker: “If tears could build a stairway/and thoughts a memory lane/I’d walk right up to heaven/and bring you home again.”")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Little Luis Andre Ortiz Ramos will not lack for toys with his cars, teddy bears, and angel pointing toward heaven while clutching a stuffed dog. He was born on December 21, 1998, and died on December 30, 1998, and is buried in the Nogales cemetery.")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F7.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Don Jack Han, buried in Tucson’s Evergreen Cemetery, was born in Tucson on July 9, 1901, and died on March 25, 1914. His tombstone includes a number of Chinese characters.")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Eugene “Geenie” Mark Jacobs, the son of B.M. and Henrietta Jacobs, was born June 19, 1880, and died November 27, 1885. He is buried in Tucson’s Evergreen Cemetery.")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F9.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Chase Matthew Nuzzo, son of Amanda Joyce Nuzzo, died on December 3, 2003, in Tucson. Chase has a wonderful playground grave marker in Sunset Cemetery in Willcox. He was survived by his mother and a twin brother, Logan.")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The inscription on Francine Cain’s grave marker reads, “How Many Hopes Lie Buried Here,” which reflected the family’s deep loss. Besides the lamb of innocence, ferns adorn her tombstone. Ferns, which grow deep in the forest, are only found by those who have honestly searched.")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F11.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Dominique Naté Jones, born on December 21, 1991, died of appendicitis on May 14, 2001. She is buried in the Arivaca Cemetery. Her stone’s inscription is a verse from “Jesus Loves the Little Children.”")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("One can only imagine the grief of the Mariscal family, who lost two young children in a year. A daughter, Julita, died in 1924, and their son Raul died in 1925. The children are buried in a common grave in Tucson’s Evergreen Cemetery.")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F13.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Marguerite Evans’s birthday is not known, but she died in Tucson on August 30, 1900, at the age of 11 years and 5 months. Her elegant tombstone in Evergreen Cemetery has an inscribed scroll and a lily of the valley decoration. The lily of the valley, one of the first flowers to bloom in the spring, symbolizes both renewal and the resurrection of Christ.")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This child buried in the Nogales Cemetery has everything, including a house where he can rest and where offerings can be made. The Mexican American practice of decorating grave sites has roots in the belief that time is a never-ending cycle of life and death.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 81
// module chunks = 0